import {
  betaBack,
  betaBusiness,
  betaBusinessBlue,
  betaPersonal,
  betaPersonalGrey,
} from "assets";

import { BetaLogo } from "components/global/Logo";
import Button from "components/global/Button";
import React from "react";
import styled from "styled-components";

export const SelectStyle = styled.div`
  margin: auto;
  max-width: 56rem;
  margin-top: 9.6rem;
  margin-bottom: 10.3rem;

  .back {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.8rem;
    height: 3.6rem;
    width: 3.6rem;
    background-color: var(--off_white);
    position: absolute;
    left: 0;

    @media (max-width: 768px) {
      position: relative;
      margin-bottom: 4.8rem;
    }
  }

  .step {
    margin-top: 4.8rem;
    margin-bottom: 2.4rem;
  }

  h1 {
    font-size: 4.8rem;
    line-height: 5.6rem;

    @media (max-width: 768px){
      font-size: 3.6rem;
      line-height: 4.2rem;
    }
  }

  h1 + p {
    font-size: 2rem;
    line-height: 2.6rem;
    margin-top: 1.2rem;
    margin-bottom: 6rem;
  }

  .accounts {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4.8rem;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }

    & > div {
      width: 25.6rem;
      height: 24rem;
      padding: 2.4rem;
      border: 1px solid var(--grey_9);
      border-radius: 8px;

      @media (max-width: 768px) {
        width: 100%;
        height: fit-content;
        :last-child {
          margin-top: 2.4rem;
        }
      }

      .hover {
        display: none;
      }

      &:hover,
      .selected {
        border-color: var(--secondary);

        & > div {
          border-color: var(--secondary);
          img {
            display: none;
          }
          .hover {
            display: block;
          }
        }
      }

      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 4.8rem;
        height: 4.8rem;
        border-radius: 0.4rem;
        border: 1px solid var(--grey_9);
      }

      h6 {
        font-size: 1.8rem;
        line-height: 2rem;
        margin-top: 2.4rem;
      }

      p {
        font-size: 1.6rem;
        line-height: 2rem;
        margin-top: 1.2rem;
      }
    }
  }

  .selected {
    display: block;
    border-color: var(--secondary) !important;
    .hover {
      display: block !important;
    }
  }

  .hide {
    display: none;
  }

  .message {
    margin: auto;
    display: block;
    margin-top: 6rem;
    margin-bottom: 2.4rem;
    @media (max-width: 768px) {
      width: 14.8rem;
    }
  }

  .allDone {
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: rgba(119, 225, 180, 0.1);
    width: 9.6rem;
    height: 9.6rem;
    @media (max-width: 768px) {
      margin-top: 18.8rem;
    }
  }

  .allDone + h3 {
    margin-top: 2.4rem;
    margin-bottom: 1.2rem;
  }

  .gotoDashboard {
    margin: auto;
    margin-top: 4.8rem;
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    margin-top: 4.8rem;
    margin-bottom: 7.2rem;
    max-width: 90%;

    .center {
      text-align: center;
    }
  }
`;

export default function SelectAccountType({
  goToNext,
  goBack,
  setAccount,
  account,
}) {
  return (
    <SelectStyle>
      <div className="backNLogo">
        <button className="back" onClick={goBack}>
          <img src={betaBack} alt="back" />
        </button>
        <BetaLogo />
      </div>
      <p className="step">
        Step 1 <span className="colorBodyText">/4</span>
      </p>
      <h1>Hey 👋 Welcome to PostPaddy </h1>
      <p className="colorBodyText">
        Select an account type that works best for you.
      </p>
      <div className="accounts">
        <div
          onClick={() => setAccount("personal")}
          className={`${account === "personal" ? "selected" : ""} accountType`}
        >
          <div className={account === "personal" ? "selected" : ""}>
            <img
              className={account === "personal" ? "hide" : ""}
              src={betaPersonalGrey}
              alt="personal"
            />
            <img className="hover" src={betaPersonal} alt="personal" />
          </div>
          <h6>Personal Account</h6>
          <p className="colorBodyText">
            Manage multiple social media accounts for a personal account.
          </p>
        </div>
        <div
          onClick={() => setAccount("business")}
          className={`${account === "business" ? "selected" : ""} accountType`}
        >
          <div className={account === "business" ? "selected" : ""}>
            <img
              className={account === "business" ? "hide" : ""}
              src={betaBusiness}
              alt="Business"
            />
            <img className="hover" src={betaBusinessBlue} alt="Business" />
          </div>
          <h6>Business Account</h6>
          <p className="colorBodyText">
            Manage multiple brands’ social media accounts for a business
            account.
          </p>
        </div>
      </div>
      <Button onClick={goToNext} disabled={!account} text="Next" width="100%" />
    </SelectStyle>
  );
}
